/* import __COLOCATED_TEMPLATE__ from './download-pdf-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { action } from '@ember/object';

type ErrorType = 'timeout' | 'failure';

interface Args {
  errorType: ErrorType;
  onClose: () => void;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

export default class DownloadPdfModal extends Component<Signature> {
  get hasTimedOut(): boolean {
    return this.args.errorType === 'timeout';
  }

  get hasFailed(): boolean {
    return this.args.errorType === 'failure';
  }

  @action
  onClose(): void {
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Conversation::DownloadPdfModal': typeof DownloadPdfModal;
    'inbox2/conversation/download-pdf-modal': typeof DownloadPdfModal;
  }
}
